import React from 'react'
import { BsLinkedin } from 'react-icons/bs';
import { FaBehanceSquare, FaHandshake } from 'react-icons/fa';

const SocialMedia = () => {
    return (
        <div className="app__social">
            <div>
                <a href="https://www.linkedin.com/in/erika-delfino"><BsLinkedin /></a>
            </div>
            <div>
                <a href="https://www.behance.net/erikadelfino"><FaBehanceSquare /></a>
            </div>
            <div>
                <a href="/#contact"><FaHandshake /></a>
            </div>

        </div>
    )
}

export default SocialMedia